import React, { useMemo } from 'react';
import AppCard from '../AppCard';
import './multiScroller.css'; // you’ll thank me later

interface IProps {
    cards: Array<any>;
}

const MultiScroller: React.FC<IProps> = React.memo(({ cards }) => {
    // double the cards so it loops seamlessly
    const doubledCards = useMemo(() => [...cards, ...cards], [cards]);

    return (
        <div className="multi-scroller">
            <div className="multi-track">
                {doubledCards.map((card, idx) => (
                    <div className="multi-slide" key={`${card.id}-${idx}`}>
                        <AppCard type="top" details={card} />
                    </div>
                ))}
            </div>
        </div>
    );
});

MultiScroller.displayName = 'MultiScroller';

export default MultiScroller;
